import type { UserSelectorState } from '@peloton/auth/redux';
import { isMe } from '@peloton/auth/redux';
import { isDefined } from '@peloton/types/isDefined';
import { isFollowedByUser } from '@engage/members/models';
import type { MemberSelectorState } from '@engage/members/selectors';
import { getMember, isMemberPrivate } from '@engage/members/selectors';

export enum OverviewPageActionTypes {
  Load = 'pelo/page/overview/Load',
}

export type OverviewPageLoadAction = {
  type: OverviewPageActionTypes.Load;
  payload: {
    meOrUserId: string;
  };
};

export const loadOverviewPage = (meOrUserId: string) => ({
  type: OverviewPageActionTypes.Load,
  payload: {
    meOrUserId,
  },
});

export const shouldShowProfile = (
  state: UserSelectorState & MemberSelectorState,
  usernameOrId: any,
): boolean => {
  const member = getMember(state, usernameOrId);
  if (!isDefined(member)) {
    return false;
  }
  return (
    isMe(state, member.id) ||
    isFollowedByUser(member) ||
    !isMemberPrivate(state, member.id)
  );
};
